/**
 * Client dell'API Arcanum2 (api.arcanum2.ch) per il CRM. Il login è lo stesso della piattaforma (JWT dell'API);
 * il token resta nella sessione del browser (sessionStorage): si perde chiudendo la scheda.
 */
const TOKEN_KEY = 'arcanum-crm-token';
const TIMEOUT_MS = 30_000;

export const API_BASE_URL: string = import.meta.env.VITE_ARCANUM_API_BASE_URL
  || (typeof location !== 'undefined' && location.hostname.endsWith('arcanum2.ch') ? 'https://api.arcanum2.ch' : 'http://localhost:4000');

export class ApiError extends Error {
  constructor(public status: number, message: string, public data: Record<string, unknown> = {}) {
    super(message);
    this.name = 'ApiError';
  }
}

export function getToken(): string | null {
  try { return sessionStorage.getItem(TOKEN_KEY); } catch { return null; }
}
export function setToken(token: string | null): void {
  try {
    if (token) sessionStorage.setItem(TOKEN_KEY, token); else sessionStorage.removeItem(TOKEN_KEY);
  } catch { /* storage non disponibile: la sessione dura quanto la pagina */ }
}

export async function apiFetch<T>(path: string, options: RequestInit = {}): Promise<T> {
  const token = getToken();
  const headers: Record<string, string> = { 'Content-Type': 'application/json', ...(options.headers as Record<string, string> | undefined) };
  if (token) headers.Authorization = `Bearer ${token}`;
  let res: Response;
  try {
    res = await fetch(`${API_BASE_URL}${path}`, { ...options, headers, signal: options.signal ?? AbortSignal.timeout(options.method === 'POST' && path.startsWith('/crm-sourcing') ? 600_000 : TIMEOUT_MS) });
  } catch {
    throw new ApiError(0, 'Impossibile raggiungere il server. Controlla la connessione.');
  }
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new ApiError(res.status, (body as { error?: string }).error || 'Errore di rete', body as Record<string, unknown>);
  return body as T;
}
